<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    :before-close="closeModal">

    <fg-input type="text"
              label="Name"
              placeholder="Name"
              v-model="user.name"/>
    <fg-input type="text"
              label="Email"
              placeholder="Email"
              v-model="user.email"/>
    <fg-input type="password"
              label="Password"
              placeholder="Password"
              v-model="user.password"/>

    <span slot="footer" class="dialog-footer">
      <button class="btn" @click="$emit('cancel')">Cancel</button>&nbsp;
      <button class="btn btn-success" @click="$emit('save', user)">Confirm</button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'Edit-User',
  props: {
    visible: Boolean,
    mode: String
  },
  data () {
    return {
      user: {
        name: '',
        email: '',
        password: ''
      }
    }
  },
  computed: {
    title () {
      return this.mode + ' User'
    }/* ,
    dialogVisible () {
      return this.visible
    } */
  },
  methods: {
    closeModal () {
      this.$emit('cancel')
    }
  }
}
</script>

<style>

</style>